import React from "react"
import { Col, Row } from "react-bootstrap"
import { resolveRichText } from "../../../utils/richText"
import StoryblokImage from "../../internal/storyblokImage/StoryblokImage"
import WidgetWrapper from "../../internal/widgetWrapper/WidgetWrapper"
import * as styles from "./TwoColumnTextImageWidget.module.scss"

function SizeKeyToWidthValues(key) {
  switch(key) {
    case "ten_two":
      return [10,2]
    case "eight_four":
      return [8,4]
    case "seven_five":
      return [7,5]
    case "six_six":
      return [6,6]
    case "five_seven":
      return [5,7]
    case "four_eight":
      return [4,8]
    case "two_ten":
      return [2,10]
    default:
      return [6,6]
  }
}

const TwoColumnTextImageWidget = ({ blok }) => {
  const text = resolveRichText(blok.text)
  const colSizes = SizeKeyToWidthValues(blok.column_sizes)

  const textCol = (
    <Col xs={colSizes[0]}>
      <div dangerouslySetInnerHTML={text} />
    </Col>
  )

  return (
    <WidgetWrapper blok={blok}>
      <div className={styles.container}>
        <Row>
          {blok.text_left === "true" ? textCol : null}
          <Col xs={colSizes[1]}>
            {blok.image ? <StoryblokImage sbImageData={blok.image} /> : null}
          </Col>
          {blok.text_left === "true" ? null : textCol}
        </Row>
      </div>
    </WidgetWrapper>
  )
}

export default TwoColumnTextImageWidget